import Icon from "@ant-design/icons";
import type { CustomIconComponentProps } from "@ant-design/icons/lib/components/Icon";

const IconSvg = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.0833 2.16667H11.5V1.58333C11.5 1.26075 11.2387 1 10.9167 1C10.5947 1 10.3333 1.26075 10.3333 1.58333V2.16667H5.66667V1.58333C5.66667 1.26075 5.40533 1 5.08333 1C4.76133 1 4.5 1.26075 4.5 1.58333V2.16667H3.91667C2.30842 2.16667 1 3.47508 1 5.08333V12.0833C1 13.6916 2.30842 15 3.91667 15H12.0833C13.6916 15 15 13.6916 15 12.0833V5.08333C15 3.47508 13.6916 2.16667 12.0833 2.16667ZM3.91667 3.33333H12.0833C13.0482 3.33333 13.8333 4.1185 13.8333 5.08333V5.66667H2.16667V5.08333C2.16667 4.1185 2.95183 3.33333 3.91667 3.33333ZM2.16667 6.83333H13.8333V7.17692C13.8246 7.1845 10.3188 10.6892 10.3188 10.6892C10.0148 10.9931 9.48517 10.9931 9.18067 10.6892L8.81083 10.3188C8.06592 9.57383 6.76742 9.57383 6.0225 10.3188L2.86258 13.4787C2.44025 13.159 2.16667 12.6521 2.16667 12.0828V6.83275V6.83333ZM12.0833 13.8333H4.15817L6.84792 11.1442C7.15183 10.8402 7.6815 10.8402 7.986 11.1442L8.35583 11.5146C9.10075 12.2595 10.3992 12.2595 11.1442 11.5146L13.8333 8.82542V12.0839C13.8333 13.0487 13.0482 13.8333 12.0833 13.8333ZM3.33333 8.875C3.33333 8.392 3.72533 8 4.20833 8C4.69133 8 5.08333 8.392 5.08333 8.875C5.08333 9.358 4.69133 9.75 4.20833 9.75C3.72533 9.75 3.33333 9.358 3.33333 8.875Z"
      fill="#151718"
    />
  </svg>
);

const DayOffIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={IconSvg} {...props} />
);

export default DayOffIcon;
